import React, { useState, useEffect, useContext } from "react";
import "./Footer.css";
import { Form, InputGroup, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { FooterData } from "../../utils/apis/footer/Footer";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";
import { Services, ServiceId } from "../../utils/apis/service/Service";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { IMG_URL } = useContext(Context);

  const [appsetup, setAppSetup] = useState({});
  const [services, setServices] = useState([]);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getAppSetup = async () => {
    const res = await FooterData();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  const getService = async () => {
    const res = await Services();

    if (res?.success) {
      setServices(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getAppSetup();
    getService();
  }, []);

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      }, 200);
    }
  };

  return (
    <>
      <footer className="Footer two_section_holder">
        <div className="container">
          <div className="row justify-content-center  mb-4">
            <div className="col-lg-3  col-md-4 mb-4">
              <div className="logo_holder">
                <img
                  src={IDS?.IMG_URL + appsetup?.logo}
                  alt="Logo"
                  className="logo_img"
                />
              </div>
              <div className="logo_text_holder">
                <p className="logo_text">
                  Address:
                  <p className="address">{appsetup.address}</p>
                </p>
              </div>
              <div className="footer_icon_holder">
                <h5 className="follow_title">Follow us on:</h5>
                <div className="footer_links">
                  {[
                    {
                      icon: faFacebookF,
                      link: " https://www.facebook.com/share/179SRys2LB/",
                    },
                    {
                      icon: faInstagram,
                      link: "https://www.instagram.com/hindustan_solar_/?hl=en",
                    },
                    {
                      icon: faLinkedinIn,
                      link: " https://www.linkedin.com/company/hbctc/",
                    },
                    {
                      icon: faYoutube,
                      link:
                        " https://youtube.com/@hindustansolar.5579?si=l_y03yd4-De9P3YP",
                    },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      className="footer_link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={item.icon} />
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Our Services</h5>
              {/* <div className=" quick_links">
                 {[
                  {
                    label: "Residential",
                    path: "/services/services-inner-page",
                  },
                  {
                    label: "Housing Society",
                    path: "/services/services-inner-page",
                  },
                  {
                    label: "Commercial & Industrial Solar",
                    path: "/services/services-inner-page",
                  },
                  {
                    label: "Consultancy & Project Advisory",
                    path: "/services/services-inner-page",
                  },
                  {
                    label: "Structural Safety & Engineering",
                    path: "/services/services-inner-page",
                  },
                  {
                    label: "Operations & Maintenance (O&M)",
                    path: "/services/services-inner-page",
                  },
                ].map((item) => (
                  <NavLink
                    key={item.path}
                    as={Link}
                    to={item.path}
                    onClick={(e) => handleNavClick(item.path, e)}
                    className={`quick_text ${
                      item.path === "/"
                        ? location.pathname === "/"
                          ? "active_quick_text"
                          : ""
                        : location.pathname.startsWith(item.path)
                        ? "active_quick_text"
                        : ""
                    }`}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div> */}
              <div className="quick_links">
                {services?.map((item) => (
                  <NavLink
                    key={item?.id}
                    as={Link}
                    to={`/services/${item?.id}`}
                    onClick={(e) => handleNavClick(`/services/${item?.id}`, e)}
                    className={`quick_text ${
                      location.pathname === `/services/${item?.id}`
                        ? "active_quick_text"
                        : ""
                    }`}
                  >
                    {htmlToReactParser.parse(item?.name)}
                  </NavLink>
                ))}
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Quick Links</h5>

              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className=" quick_links">
                    {[
                      { label: "Home", path: "/" },
                      { label: "Blogs", path: "/blog" },
                      { label: "Services", path: "/services" },
                      { label: "Gallery", path: "/gallery" },
                      { label: "About us", path: "/about-us" },
                    ].map((item) => (
                      <NavLink
                        key={item.path}
                        as={Link}
                        to={item.path}
                        onClick={(e) => handleNavClick(item.path, e)}
                        className={`quick_text ${
                          item.path === "/"
                            ? location.pathname === "/"
                              ? "active_quick_text"
                              : ""
                            : location.pathname.startsWith(item.path)
                            ? "active_quick_text"
                            : ""
                        }`}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className=" quick_links">
                    {[
                      { label: "FAQ", path: "/faq" },
                      { label: "Contact Us", path: "/contact-us" },
                      { label: "Privacy Policy", path: "/privacy-policy" },
                      { label: "Terms Of Service", path: "/terms-of-services" },
                      { label: "Subsidy & Policies", path: "/subsidy-policy" },
                    ].map((item) => (
                      <NavLink
                        key={item.path}
                        as={Link}
                        to={item.path}
                        onClick={(e) => handleNavClick(item.path, e)}
                        className={`quick_text ${
                          item.path === "/"
                            ? location.pathname === "/"
                              ? "active_quick_text"
                              : ""
                            : location.pathname.startsWith(item.path)
                            ? "active_quick_text"
                            : ""
                        }`}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-12 col-md-4 col_div">
              <h5 className="footer_section_title">Contact</h5>
              <div className="footer_links">
                <div className="email_holder">
                  <p className="email_title"> Call:</p>
                  <a
                    href={`https://wa.me/${appsetup.contactno?.replace(
                      /\D/g,
                      "",
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="email_text">{appsetup.contactno}</p>
                  </a>
                </div>

                <div className="email_holder">
                  <p className="email_title"> Email:</p>
                  <a href={`mailto:${appsetup.email}`}>
                    <p className="email_text">{appsetup.email}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer_text_div">
          <p className="footer_text">
            Copyright ©2026 All Rights Reserved. Developed by
            <a
              href="https://profcymaglobal.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="link_text"
            >
              {" "}
              {""}
              Profcyma
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
